import React from 'react';

export function LightningSvg() {
  return (
    <svg
      width="15px"
      height="23px"
      viewBox="0 0 15 23"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>primary 2</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Clarity-integration-Copy"
          transform="translate(-750, -1326)"
          stroke="#B0C4D2"
          strokeWidth="2.1"
        >
          <g id="Group-2" transform="translate(149, 1216)">
            <g id="primary-2" transform="translate(603, 112)">
              <polygon
                id="primary"
                points="0 9.5 5.5 11.6111111 4.4 19 11 9.5 6.6 7.38888889 7.7 0"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
